import { CalendarView } from '../view/index';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import DrawerLayout from '../../DrawerLayout';
import { CalendarIcon } from '../../Icons';

export default function MainCalendar() {
  return (
    <DrawerLayout title="Work hub" icon={<CalendarIcon style={{ color: '#6200ea' }} />} fillHeight hub="work">
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <CalendarView sx={{ width: '100%' }} />
      </LocalizationProvider>
    </DrawerLayout>
  );
}
